import ClipboardJS from 'clipboard';

($ => {
  const expr = '.js-clipboard';
  const init = () => {
    let clipboard = new ClipboardJS(expr, { text: setText });
    $('body').on({
      click: onClick,
      mouseenter: onMouseEnter
    }, expr);
  }
  const setText = trg => {
    const $element = $(trg);
    const randomQrcodeUrl = $element.data('reservation-random-qrcode-url');
    const reservationType = $element.data('reservation-type');

    switch (reservationType) {
      case 'event':
        return process.env.WORDPRESS_URL + process.env.JS_BASE_URL + 'customer/event_sharing_qrcodes/' + randomQrcodeUrl;
        break;
      case 'barbecue':
        return process.env.WORDPRESS_URL + process.env.JS_BASE_URL + 'customer/barbecue_sharing_qrcodes/' + randomQrcodeUrl;
        break;
      case 'camping':
        return process.env.WORDPRESS_URL + process.env.JS_BASE_URL + 'customer/group_of_camping_sharing_qrcodes/' + randomQrcodeUrl;
        break;
      case 'day_camping':
        return process.env.WORDPRESS_URL + process.env.JS_BASE_URL + 'customer/day_camping_sharing_qrcodes/' + randomQrcodeUrl;
        break;
    }
  }

  const onClick = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    $element.tooltip('dispose').tooltip({title: 'コピーしました'}).tooltip('show');
  }
  const onMouseEnter = e => {
    const $element = $(e.currentTarget);
    $element.tooltip('dispose').tooltip({title: 'クリップボードにコピーします。'}).tooltip('show');
  }
  $(init);
})(jQuery);
